import React, { useState, useRef } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../config";

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [oldPasswordError, setOldPasswordError] = useState("");
  const debounceRef = useRef(null);
  const navigate = useNavigate();

  // Verify old password on change (debounced)
  const verifyOldPassword = async (password) => {
    if (!password) {
      setOldPasswordError("");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(
        `${BASE_URL}api/user/verify-password`,
        { password },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.data.valid) {
        setOldPasswordError("Current password is incorrect");
      } else {
        setOldPasswordError("");
      }
    } catch (err) {
      setOldPasswordError("Error verifying password");
    }
  };

  const handleOldPasswordChange = (e) => {
    const value = e.target.value;
    setOldPassword(value);
    setOldPasswordError("");
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      verifyOldPassword(value);
    }, 400);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!oldPassword) {
      toast.error("Current password is required");
      return;
    }
    if (oldPasswordError) {
      toast.error(oldPasswordError);
      return;
    }
    if (!newPassword || newPassword.length < 6) {
      toast.error("New password must be at least 6 characters");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    if (oldPassword === newPassword) {
      toast.error("New password must be different from current password");
      return;
    }
    setSubmitting(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${BASE_URL}api/user/change-password`,
        { oldPassword, newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log("Change password response:", response.data);
      toast.success("Password changed successfully.");
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setTimeout(() => {
        navigate("/login");
      }, 1000); // Redirect to login after 1 second
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to change password");
      console.log("Change password error:", error.response || error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="container d-flex justify-content-center align-items-center flex-grow-1">
        <div className="login-box p-4 shadow rounded bg-white" style={{ width: "100%", maxWidth: "400px" }}>
          <div className="text-center mb-4">
            <img
              src="https://res.cloudinary.com/softisans-com/image/upload/v1592236220/Logo/Softisans-Logo.png"
              alt="Softisans Logo"
              style={{ maxWidth: "180px", width: "60%", height: "auto" }}
            />
          </div>
          <h2 className="text-center">Change Password</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <input
                type="password"
                placeholder="Current Password"
                className={`form-control ${oldPasswordError ? "is-invalid" : ""}`}
                value={oldPassword}
                onChange={handleOldPasswordChange}
                disabled={submitting}
              />
              {oldPasswordError && (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {oldPasswordError}
                </div>
              )}
            </div>
            <div className="form-group mb-3">
              <input
                type="password"
                placeholder="New Password"
                className="form-control"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                disabled={submitting}
              />
            </div>
            <div className="form-group mb-3">
              <input
                type="password"
                placeholder="Confirm New Password"
                className="form-control"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                disabled={submitting}
              />
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <button type="submit" className="btn btn-primary" disabled={submitting}>
                {submitting ? "Changing..." : "Change Password"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer /> {/* Add this line for toast notifications */}
    </div>
  );
};

export default ChangePassword;
